import React, { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { BiEdit } from "react-icons/bi";
import { BsCheckLg } from "react-icons/bs";
import { CgPlayListAdd } from "react-icons/cg";
import { MdDeleteOutline } from "react-icons/md";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import EditJobModal from "../../../components/Administration/Jobs/ManageJobs/EditJobModal";
import EditInvoiceModal from "../../../components/modelpopup/EditInvoiceModal";

export default function TableForm({
  catalogNum,
  month,
  setMonth,
  setCatalogNum,
  invoiceDetails,
  setInvoiceDetails,
  catagory,
  setCatagory,
  date1,
  date2,
  setDate1,
  setDate2,
  details,
  setDetails,
  quantity,
  setQuantity,
  price,
  setPrice,
  discountForProduct,
  setDiscountForProduct,
  amount,
  setAmount,
  setList,
  total,
  setTotal,
  perTax,
  setPerTax,
  tax,
  setTax,
  amounts,
  setAmounts,
  discount,
  setDiscount,
  totalAfDiscount,
  setTotalAfDiscount,
  isExemption,
  setIsExemption,
  totalAfTax,
  setTotalAfTax,
  exemptionAmount,
  setExemptionAmount,
  list,
  revenues,
  setRevenues,
  revenuesExempt,
  setRevenuesExempt,
  expenses,
  setExpenses,
  fixedExpenses,
  setFixedExpenses,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const numFocus = useRef(null);
  const [showExit, setShowExit] = useState(false); // show/hide modal
  const [rowToDelete, setRowToDelete] = useState(null); // track id

  useEffect(() => {
    if (localStorage.getItem("list") === undefined) {
      setList(JSON.parse(localStorage.getItem("list")));
      localStorage.setItem("list", JSON.stringify(list));
    }

    if (
      list.length == 0 &&
      revenues.length == 0 &&
      revenuesExempt.length == 0 &&
      expenses.length == 0 &&
      fixedExpenses.length == 0 &&
      localStorage.getItem("list") != undefined
    ) {
      setList(JSON.parse(localStorage.getItem("list")));
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      // console.log("EXEMPTTTTTTTT:  useEffect ",revenuesExempt)
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenuesExempt") != undefined &&
      localStorage.getItem("revenues") === undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("fixedExpenses") === undefined
      )
    ) {
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      (localStorage.getItem("expenses") != undefined ||
        localStorage.getItem("expenses") != null) &&
      localStorage.getItem("revenues") === undefined &&
      (localStorage.getItem("revenuesExempt") === undefined)(
        localStorage.getItem("fixedExpenses") === undefined
      )
    ) {
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      (localStorage.getItem("fixedExpenses") != undefined ||
        localStorage.getItem("fixedExpenses") != null) &&
      localStorage.getItem("revenues") === undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("revenuesExempt") != undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("fixedExpenses") === undefined
      )
    ) {
      setList(JSON.parse(localStorage.getItem("list")));
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenuesExempt") != undefined &&
      localStorage.getItem("revenues") === undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("fixedExpenses") === undefined
      )
    ) {
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("expenses") != undefined &&
      localStorage.getItem("revenues") != undefined &&
      (localStorage.getItem("revenuesExempt") === undefined)(
        localStorage.getItem("fixedExpenses") === undefined
      )
    ) {
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("fixedExpenses") != undefined &&
      localStorage.getItem("revenues") === undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenuesExempt") != undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("fixedExpenses") === undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("revenuesExempt") != undefined
      )
    ) {
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("revenuesExempt") != undefined
      )
    ) {
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") === undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("revenuesExempt") != undefined
      )
    ) {
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") === undefined &&
      localStorage.getItem("fixedExpenses") === undefined &&
      (localStorage.getItem("expenses") === undefined)(
        localStorage.getItem("revenuesExempt") === undefined
      )
    ) {
      setList(JSON.parse(localStorage.getItem("list")));
    } else if (
      list.length == 0 &&
      localStorage.getItem("revenues") != undefined &&
      localStorage.getItem("fixedExpenses") != undefined &&
      (localStorage.getItem("expenses") != undefined)(
        localStorage.getItem("revenuesExempt") != undefined
      )
    ) {
      setRevenues(JSON.parse(localStorage.getItem("revenues")));
      setExpenses(JSON.parse(localStorage.getItem("expenses")));
      setFixedExpenses(JSON.parse(localStorage.getItem("fixedExpenses")));
      setRevenuesExempt(JSON.parse(localStorage.getItem("revenuesExempt")));
      setList(JSON.parse(localStorage.getItem("list")));
    }
  }, [isExemption, list, revenues]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const newItems = {
      id: uuidv4(),
      catalogNum,
      details,
      quantity,
      price,
      discountForProduct,
      amount,
      discount,
      isExemption,
      exemptionAmount,
      invoiceDetails,
      catagory,
      date1,
      date2,
    };

    setDetails("");
    setQuantity(1);
    setPrice("");
    setAmount("");
    setCatalogNum("");
    setInvoiceDetails(invoiceDetails);
    setCatagory(catagory);
    setDiscountForProduct("");
    setIsExemption(false);
    list = list.filter((row) => row.name != "yara");
    setList([...list, newItems]);
    setIsEditing(false);
    localStorage.setItem("list", JSON.stringify([...list, newItems]));
    if (catagory == "إيرادات" && !isExemption) {
      setRevenues([...revenues, newItems]);
      localStorage.setItem("revenues", JSON.stringify([...revenues, newItems]));
    } else if (catagory == "إيرادات" && isExemption) {
      console.log("Exemption Here", catagory, isExemption);

      setRevenuesExempt([...revenuesExempt, newItems]);
      localStorage.setItem(
        "revenuesExempt",
        JSON.stringify([...revenuesExempt, newItems])
      );
    } else if (catagory == "مصاريف عادية" && !isExemption) {
      setExpenses([...expenses, newItems]);
      localStorage.setItem("expenses", JSON.stringify([...expenses, newItems]));
    } else if (catagory == "مصاريف أصول ثابتة" && !isExemption) {
      setFixedExpenses([...fixedExpenses, newItems]);
      localStorage.setItem(
        "fixedExpenses",
        JSON.stringify([...fixedExpenses, newItems])
      );
    }

    numFocus.current.focus();
  };

  // Calculate items amount function
  useEffect(() => {
    const calculateAmount = (amount) => {
      let dis = discountForProduct / 100;
      let rs = (price - price * dis) * quantity;
      setAmount(rs);
    };

    calculateAmount(amount);
  }, [
    amount,
    price,
    quantity,
    setAmount,
    discountForProduct,
    setDiscountForProduct,
    perTax,
  ]);

  // Calculate total amount of items in table
  useEffect(() => {
    // ams ==>amounts
    let ams = 0;
    let exmpams = 0;
    list.map((item) => {
      if (item.isExemption) {
        exmpams += item.amount;
      } else {
        ams += item.amount;
      }
      setAmounts(ams);
      setExemptionAmount(exmpams);
    });

    let taf = 0;
    taf = ams * 1 - ams * 1 * (discount / 100);
    setTotalAfDiscount(taf);

    // tx ==> tax
    let tx = 0;
    tx = (taf * (perTax / 100)).toFixed(2);
    setTax(tx);

    let ttaftx = tx * 1 + taf * 1;
    setTotalAfTax(ttaftx);

    // tt ==> total
    let tt = 0;
    tt = taf + tx * 1;
    setTotal(tt + exemptionAmount);
  }, [
    amount,
    discountForProduct,
    price,
    quantity,
    list,
    amounts,
    discount,
    perTax,
  ]);

  // Edit function
  const editRow = (id) => {
    setIsEditing(true);
    if (list.length == 1) {
      let newi = { name: "yara" };
      list.push(newi);
    }
    const editingRow = list.find((row) => row.id === id);
    setList(list.filter((row) => row.id !== id));
    localStorage.setItem(
      "list",
      JSON.stringify(list.filter((row) => row.id !== id))
    );
    setDetails(editingRow.details);
    setQuantity(editingRow.quantity);
    setPrice(editingRow.price);
    setCatalogNum(editingRow.catalogNum);
    setIsExemption(editingRow.isExemption);
    setDiscountForProduct(editingRow.discountForProduct);
    setInvoiceDetails(editingRow.invoiceDetails);
    setCatagory(editingRow.catagory);
    setDate1(editingRow.date1);
    setDate2(editingRow.date2);
    if (catagory == "إيرادات" && !isExemption) {
      setRevenues(revenues.filter((row) => row.id !== id));
      localStorage.setItem(
        "revenues",
        JSON.stringify(revenues.filter((row) => row.id !== id))
      );
    } else if (catagory == "إيرادات" && isExemption) {
      localStorage.setItem(
        "revenuesExempt",
        JSON.stringify(revenuesExempt.filter((row) => row.id !== id))
      );
      setRevenuesExempt(revenuesExempt.filter((row) => row.id !== id));
    } else if (catagory == "مصاريف عادية" && !isExemption) {
      localStorage.setItem(
        "expenses",
        JSON.stringify(expenses.filter((row) => row.id !== id))
      );
      setExpenses(expenses.filter((row) => row.id !== id));
    } else if (catagory == "مصاريف أصول ثابتة" && !isExemption) {
      localStorage.setItem(
        "fixedExpenses",
        JSON.stringify(fixedExpenses.filter((row) => row.id !== id))
      );
      setFixedExpenses(fixedExpenses.filter((row) => row.id !== id));
    }
  };
  const handleClear = () => {
    window.localStorage.removeItem("list");
    window.localStorage.removeItem("revenues");
    window.localStorage.removeItem("revenuesExempt");
    window.localStorage.removeItem("fixedExpenses");
    window.localStorage.removeItem("expenses");

    window.location.reload(true);
  };
  const deleteRow = (id) => {
    setRowToDelete(id);
    setShowExit(true); // show modal instead of window.confirm
  };

  // Delete function
  // const deleteRow = (id) => {
  //   const confirmDelete = window.confirm(
  //     "هل أنت متأكد أنك تريد حذف هذا السطر؟"
  //   );

  //   if (!confirmDelete) return;

  //   let x = list.filter((row) => row.id == id);
  //   isExemption = x[0].isExemption;

  //   if (list.length == 1) {
  //     handleClear();
  //   } else {
  //     const updatedList = list.filter((row) => row.id !== id);
  //     setList(updatedList);
  //     localStorage.setItem("list", JSON.stringify(updatedList));

  //     if (catagory === "إيرادات" && !isExemption) {
  //       const updatedRevenues = revenues.filter((row) => row.id !== id);
  //       setRevenues(updatedRevenues);
  //       localStorage.setItem("revenues", JSON.stringify(updatedRevenues));
  //     } else if (catagory === "إيرادات" && isExemption) {
  //       const updatedRevenuesExempt = revenuesExempt.filter(
  //         (row) => row.id !== id
  //       );
  //       setRevenuesExempt(updatedRevenuesExempt);
  //       localStorage.setItem(
  //         "revenuesExempt",
  //         JSON.stringify(updatedRevenuesExempt)
  //       );
  //     } else if (catagory === "مصاريف عادية" && !isExemption) {
  //       const updatedExpenses = expenses.filter((row) => row.id !== id);
  //       setExpenses(updatedExpenses);
  //       localStorage.setItem("expenses", JSON.stringify(updatedExpenses));
  //     } else if (catagory === "مصاريف أصول ثابتة" && !isExemption) {
  //       const updatedFixedExpenses = fixedExpenses.filter(
  //         (row) => row.id !== id
  //       );
  //       setFixedExpenses(updatedFixedExpenses);
  //       localStorage.setItem(
  //         "fixedExpenses",
  //         JSON.stringify(updatedFixedExpenses)
  //       );
  //     }
  //   }
  // };
  const handleDeleteRow = () => {
    const id = rowToDelete;
    if (!id) return;

    const x = list.find((row) => row.id === id);
    const isExemption = x?.isExemption;

    if (list.length === 1) {
      handleClear();
    } else {
      const updatedList = list.filter((row) => row.id !== id);
      setList(updatedList);
      localStorage.setItem("list", JSON.stringify(updatedList));

      if (catagory === "إيرادات" && !isExemption) {
        const updatedRevenues = revenues.filter((row) => row.id !== id);
        setRevenues(updatedRevenues);
        localStorage.setItem("revenues", JSON.stringify(updatedRevenues));
      } else if (catagory === "إيرادات" && isExemption) {
        const updatedRevenuesExempt = revenuesExempt.filter(
          (row) => row.id !== id
        );
        setRevenuesExempt(updatedRevenuesExempt);
        localStorage.setItem(
          "revenuesExempt",
          JSON.stringify(updatedRevenuesExempt)
        );
      } else if (catagory === "مصاريف عادية" && !isExemption) {
        const updatedExpenses = expenses.filter((row) => row.id !== id);
        setExpenses(updatedExpenses);
        localStorage.setItem("expenses", JSON.stringify(updatedExpenses));
      } else if (catagory === "مصاريف أصول ثابتة" && !isExemption) {
        const updatedFixedExpenses = fixedExpenses.filter(
          (row) => row.id !== id
        );
        setFixedExpenses(updatedFixedExpenses);
        localStorage.setItem(
          "fixedExpenses",
          JSON.stringify(updatedFixedExpenses)
        );
      }
    }

    setRowToDelete(null); // reset
    setShowExit(false); // close modal
  };

  return (
    <div className="row card">
      <div className="row card-body">
        <form onSubmit={handleSubmit}>
          <div className="table-responsive">
            <table className="table table-hover table-white">
              <thead>
                <tr className="text-primary">
                  <th>رقم الفاتورة </th>
                  <th className="col-md-2"> تفاصيل الفاتورة </th>
                  <th className="col-md-2 ">نوع القيد </th>
                  <th>تاريخ الفاتورة </th>
                  <th>تاريخ الاستحقاق </th>

                  <th>قيمة الفاتورة </th>

                  <th>مجموع</th>
                  <th title="معفي من ضريبة القيمة المضافة ">معفي من ض.ق.م </th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      required
                      className="form-control"
                      type="text"
                      ref={numFocus}
                      value={catalogNum}
                      onChange={(e) => setCatalogNum(e.target.value)}
                    />
                  </td>

                  <td>
                    <select
                      id="tax"
                      className="select floating  taxx-select invoice-select"
                      name="tax"
                      // value={contact.tax}
                      onChange={(e) => setInvoiceDetails(e.target.value)}

                      //  onChange={handleChange}
                    >
                      <option value="فاتورة ضريبية">فاتورة ضريبية </option>
                      <option value="وصل بدون ضريبة"> وصل بدون ضريبة</option>
                      <option value="فاتورة وصل"> فاتورة وصل</option>
                      <option value="فاتورة مقاصة">فاتورة مقاصة </option>

                      <option value="قيد">قيد</option>
                      <option value="قيد عكسي">قيد عكسي </option>
                      <option value="عمولة">عمولة </option>
                    </select>
                  </td>
                  <td>
                    <select
                      id="tax2"
                      className="select floating  taxx-select invoice-select"
                      name="tax2"
                      // value={contact.tax}
                      onChange={(e) => setCatagory(e.target.value)}
                      //  onChange={handleChange}
                    >
                      <option value="إيرادات">إيرادات</option>
                      <option value="مصاريف عادية"> مصاريف عادية</option>
                      <option value="مصاريف أصول ثابتة">
                        {" "}
                        مصاريف أصول ثابتة{" "}
                      </option>
                    </select>
                  </td>
                  <td>
                    <div className="form-group">
                      <div className="">
                        <input
                          required
                          className="form-control "
                          type="date"
                          style={{ fontSize: "20px" }}
                          value={date1}
                          onChange={(e) => setDate1(e.target.value)}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="form-group">
                      <div className="">
                        <input
                          required
                          className="form-control "
                          type="date"
                          style={{ fontSize: "20px" }}
                          value={date2}
                          onChange={(e) => setDate2(e.target.value)}
                        />
                      </div>
                    </div>
                  </td>

                  <td>
                    <input
                      className="form-control"
                      // style={{ width: '100px' }}
                      type="text"
                      value={price}
                      required
                      onChange={(e) => setPrice(e.target.value)}
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      readOnly
                      // style={{ width: '120px' }}
                      type="text"
                      value={amount}
                    />
                  </td>
                  <td>
                    <input
                      onChange={(e) => {
                        setIsExemption(e.target.checked);
                      }}
                      style={{ width: "80px" }}
                      type="checkbox"
                      checked={isExemption}
                    />
                    <span className="pb-5" style={{ color: "white" }}>
                      {isExemption ? "نعم" : "لا"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={10} className="text-center">
                    <button type="submit" className="text-success font-18 btn">
                      {isEditing ? (
                        <span className="fs-4" title="تعديل ">
                          تعديل <BiEdit size={40} />{" "}
                        </span>
                      ) : (
                        <span className="fs-4" title="إضافة ">
                          إضافة <CgPlayListAdd size={40} />{" "}
                        </span>
                      )}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <div className="table-responsive">
          <table className="table table-hover table-white">
            <thead>
              <tr className="text-primary">
                <th style={{ width: "20px" }}>#</th>
                <th>رقم الفاتورة </th>
                <th className="col-md-2 ">تفاصيل الفاتورة </th>
                <th className="col-md-2 ">نوع القيد </th>

                <th>تاريخ الفاتورة </th>
                <th>تاريخ الاستحقاق </th>

                <th>قيمة الفاتورة </th>

                <th>مجموع</th>
                <th title="معفي من ضريبة القيمة المضافة ">معفي من ض.ق.م </th>
                <th>
                  {" "}
                  <i className="material-icons">more_vert</i>
                </th>
                {/* <th>حذف </th> */}
                {/* <th> </th> */}
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.catalogNum}
                    />
                  </td>
                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.invoiceDetails}
                    />
                  </td>
                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.catagory}
                    />
                  </td>
                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.date1}
                    />
                  </td>
                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.date2}
                    />
                  </td>

                  <td>
                    <input
                      readOnly
                      className="form-control"
                      type="text"
                      value={item.price}
                    />
                  </td>

                  <td>
                    <input
                      readOnly
                      className="form-control amount"
                      type="text"
                      value={item.amount}
                    />
                  </td>
                  <td className="text-center">
                    <a className="text-success font-18 ">
                      {item.isExemption ? (
                        <BsCheckLg color="yellow" size={30} />
                      ) : (
                        ""
                      )}
                    </a>
                  </td>
                  <td className="text-center">
                    {/* <a
                      onClick={(e) => {
                        editRow(item.id);
                      }}
                      className="text-success font-18 pointer-mk"
                      title="تعديل"
                    >
                      <BiEdit size={30} />
                    </a> */}
                    <div className="dropdown dropdown-action text-end">
                      <Link
                        to="#"
                        className="action-icon dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="material-icons">more_vert</i>
                      </Link>
                      <div className="dropdown-menu p-0 action dropdown-menu-right rounded-1 text-end">
                        <Link
                          className="dropdown-item"
                          to="#"
                          data-bs-target="#edit_type"
                          onClick={(e) => {
                            editRow(item.id);
                          }}
                        >
                          <i className="fa fa-pencil text-success" /> تعديل
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="#"
                          data-bs-target="#delete"
                          onClick={(e) => deleteRow(item.id)}
                        >
                          <i className="fa fa-trash  text-danger" /> حذف
                        </Link>
                        <Link
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-invoice"

                          // onClick={(e) => deleteRow(item.id)}
                        >
                          <i className="fa fa-pencil text-success" /> تعديل مفصل
                        </Link>
                      </div>
                    </div>
                  </td>
                  {/* <td className="text-center">
                    <a
                      onClick={(e) => deleteRow(item.id)}
                      className="text-danger font-18 pointer-mk"
                      title="حذف"
                    >
                      <MdDeleteOutline size={30} />
                    </a>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={showExit} onHide={() => setShowExit(false)}>
        <Modal.Header />
        <Modal.Title className="text-center text-primary">
          تأكيد الحذف
        </Modal.Title>

        <Modal.Body>
          <div className="">
            <p className="text-center fs-4">هل تريد حذف القيد ؟</p>
          </div>
        </Modal.Body>
        <hr className="text-primary"></hr>
        <Modal.Footer>
          <Button variant="secondary w-25" onClick={() => setShowExit(false)}>
            لا
          </Button>
          <Button variant="primary w-25" onClick={handleDeleteRow}>
            نعم
          </Button>
        </Modal.Footer>
      </Modal>

      <EditInvoiceModal />
    </div>
  );
}
